// Traduction : fr (source des clés), en, de ; chaque libellé est
// surchargeable par l'hôte (option labels).
import { de } from './de'
import { en } from './en'
import { fr } from './fr'

export type MessageKey = keyof typeof fr
export type Messages = Record<MessageKey, string>
export type Locale = 'fr' | 'en' | 'de'
export type Params = Record<string, string | number>
export type Translate = (key: MessageKey, params?: Params, fallback?: string) => string

export const dictionaries: Record<Locale, Messages> = { fr, en, de }

/** Remplace {param} dans un gabarit. */
export function format(template: string, params?: Params): string {
  return params ? template.replace(/\{(\w+)\}/g, (m, k: string) => (k in params ? String(params[k]) : m)) : template
}

/** Traducteur générique : réutilisé par le tableau de suivi pour ses libellés. */
export function translator<K extends string>(dict: Record<K, string>, overrides: Partial<Record<K, string>> = {}) {
  return (key: K, params?: Params, fallback?: string): string => format(overrides[key] ?? dict[key] ?? fallback ?? key, params)
}

export function createI18n(locale: Locale, overrides: Partial<Messages> = {}): Translate {
  return translator<MessageKey>(dictionaries[locale] ?? fr, overrides)
}
